import { useState } from 'react';
import { Link } from 'react-router-dom';
import { QuestionMarkCircleIcon, Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

interface MobileNavProps {
  recoveryCode?: string;
}

const MobileNav = ({ recoveryCode }: MobileNavProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <nav id="mobile-nav" className="fixed top-0 left-0 right-0 bg-white border-b border-gray-200 z-50 md:hidden">
        <div className="px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJzNC40OCAxMCAxMCAxMCAxMC00LjQ4IDEwLTEwUzE3LjUyIDIgMTIgMnptMCAxOGMtNC40MiAwLTgtMy41OC04LThzMy41OC04IDgtOCA4IDMuNTggOCA4LTMuNTggOC04IDh6IiBmaWxsPSIjNDI4NWY0Ii8+PHBhdGggZD0iTTEyIDZ2Nmw0LjIgNC4yIiBzdHJva2U9IiM0Mjg1ZjQiIHN0cm9rZS13aWR0aD0iMiIvPjwvc3ZnPg==" alt="DEJA" className="w-8 h-8" />
            <span className="text-base font-medium">DEJA Check-in</span>
          </div>
          <div className="flex items-center gap-2">
            <button className="p-2 rounded-full hover:bg-gray-100 text-gray-600" aria-label="Help">
              <QuestionMarkCircleIcon className="w-6 h-6" />
            </button>
            <button 
              onClick={() => setIsMenuOpen(true)}
              className="p-2 rounded-full hover:bg-gray-100 text-gray-600" 
              aria-label="Menu"
            >
              <Bars3Icon className="w-6 h-6" />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Navigation Menu */}
      <div 
        className={`fixed top-0 bottom-0 right-0 w-64 bg-white shadow-lg transform transition-transform duration-300 z-50 ${
          isMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <span className="font-bold text-lg">Menu</span>
          <button 
            onClick={() => setIsMenuOpen(false)}
            className="p-2 rounded-full hover:bg-gray-100" 
            aria-label="Close menu"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>
        <div className="py-2">
          <Link to="/" className="flex items-center gap-3 px-4 py-3 text-primary bg-blue-50 border-l-4 border-primary">
            <span>Check-in</span>
          </Link>
          <Link to="/history" className="flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-gray-50">
            <span>History</span>
          </Link>
          <a 
            href={`https://sop.nothingtodo.me/login${recoveryCode ? `?code=${recoveryCode}` : ''}`} 
            className="flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-gray-50"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>SOP System</span>
          </a>
          <a 
            href={`https://ts.nothingtodo.me${recoveryCode ? `?code=${recoveryCode}` : ''}`}
            className="flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-gray-50"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>Task System</span>
          </a>
          <button className="flex items-center gap-3 px-4 py-3 text-red-500 hover:bg-red-50 w-full text-left">
            <span>Logout</span>
          </button>
        </div>
      </div>

      {/* Mobile Nav Overlay */}
      <div 
        className={`fixed inset-0 bg-black transition-opacity duration-300 z-40 md:hidden ${
          isMenuOpen ? 'bg-opacity-50 visible' : 'bg-opacity-0 invisible'
        }`}
        onClick={() => setIsMenuOpen(false)}
      />
    </>
  );
};

export default MobileNav; 